var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    _vm._g(
      { attrs: { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 41 40" } },
      _vm.$listeners
    ),
    [
      _c("path", {
        attrs: {
          fill: "#635BFF",
          "fill-rule": "evenodd",
          d:
            "M10.256 0h20.493c3.398 0 4.633.357 5.872 1.02A6.894 6.894 0 0 1 39.48 3.9c.666 1.244 1.019 2.473 1.019 5.87v20.483c0 3.397-.353 4.63-1.02 5.874a6.946 6.946 0 0 1-2.86 2.858C35.382 39.648 34.148 40 30.75 40H10.256c-3.398 0-4.633-.353-5.876-1.015a6.96 6.96 0 0 1-2.86-2.858C.853 34.884.5 33.65.5 30.254V9.77c0-3.396.353-4.625 1.02-5.869A6.91 6.91 0 0 1 4.38 1.02C5.633.357 6.858 0 10.256 0z",
          "clip-rule": "evenodd"
        }
      }),
      _c("path", {
        attrs: {
          fill: "#fff",
          "fill-rule": "evenodd",
          d:
            "M19.476 15.402c0-.921.756-1.276 2.008-1.276 1.795 0 4.063.544 5.858 1.512v-5.551C25.382 9.307 23.444 9 21.484 9c-4.795 0-7.984 2.504-7.984 6.685 0 6.52 8.976 5.48 8.976 8.292 0 1.086-.945 1.44-2.268 1.44-1.96 0-4.464-.802-6.449-1.889v5.622a16.375 16.375 0 0 0 6.45 1.346c4.913 0 8.29-2.433 8.29-6.661-.023-7.04-9.023-5.787-9.023-8.433z",
          "clip-rule": "evenodd"
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }